import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useLocalStorage } from "@vueuse/core";

import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";

import UiCollapse from "@/components/ui/UiCollapse.vue";

import VotingModule from "./VotingModule.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuVoting',
  setup(__props) {

const expanded = useLocalStorage("expand-quick-actions", true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiGroup, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    default: _withCtx(() => [
      _createVNode(UiCollapse, {
        modelValue: _unref(expanded),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(expanded) ? (expanded).value = $event : null))
      }, {
        header: _withCtx(() => [
          _createVNode(UiHeader, { title: "Оценка удовлетворённости качества питания" }, {
            right: _withCtx(() => [
              _createVNode(UiIcon, {
                size: 18,
                class: _normalizeClass([{ 'transform-gpu rotate-180': _unref(expanded) }, "transition duration-200"]),
                icon: "ChevronDown"
              }, null, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(VotingModule)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 16))
}
}

})